
export const validateLicense = (stateCode, licenseNumber) => {
  var regMichigan = /^[a-zA-Z]{1}[0-9]{10}$|^[a-zA-Z]{1}[0-9]{12}$/;
  var regNewJersey = /^[a-zA-Z]{1}[0-9]{14}$/;
  var regPennsylvania = /^[0-9]{8}$/;


  if (stateCode == undefined || licenseNumber == undefined) {
    return "";
  }
  if (stateCode == 'MI' || stateCode == 'Michigan') {
    if (regMichigan.test(licenseNumber)) {
      return ValidateNumerationFixed(licenseNumber);
    }
    return "Must be 1Alpha+10Numeric; or 1Alpha+12Numeric";
  }

  if (stateCode == 'New Jersey') {
    if (regNewJersey.test(licenseNumber)) {
      return ValidateNumerationFixed(licenseNumber);
    }
    return "Must be 1Alpha+14Numeric";
  }

  if (stateCode == 'Pennsylvania') {
    if (regPennsylvania.test(licenseNumber)) {
      return ValidateNumerationFixed(licenseNumber);
    }
    return "Must be 8Numeric";
  }
}

function ValidateNumerationFixed(licenseNumber) {
  //Get only numbers
  let licenseNumbers = licenseNumber.replace(/\D/g, "");
  let licenseNumbersArr = licenseNumbers.split("");

  //Same number validation
  let setNumbers = new Set(licenseNumbersArr);
  setNumbers = [...setNumbers].join("");
  if (setNumbers.length == 1) {
    return "Please add a valid format.";
  }

  const blockSequences = [
    "123456789", "987654321",
    "12345678", "87654321", "01234567", "76543210"
  ];

  if (blockSequences.some(seq => licenseNumbers.includes(seq))) {
    return "Please add a valid format.";
  }

  return "";
}

function validateExpression(expression, value, error) {
  if (expression.test(value) == true) {
    return "";
  }
  return error;
}

